var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('Form',{ref:"createRedirect",attrs:{"redirect":_vm.redirect,"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }